import { SITE_BASE_URL, SITE_NAME } from '@/constants/site'
import { STORE_INFO } from '@/constants/store-info'

interface OpeningHoursSpecificationJsonLd {
  '@type': 'OpeningHoursSpecification'
  dayOfWeek: string[]
  opens: string
  closes: string
}

interface FloristJsonLd {
  '@type': 'Florist'
  '@id': string
  name: string
  url: string
  email: string
  openingHoursSpecification: OpeningHoursSpecificationJsonLd[]
  areaServed: string
}

export interface FloristJsonLdGraph {
  '@context': 'https://schema.org'
  '@graph': FloristJsonLd[]
}

const ALL_WEEK_DAYS = [
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
  'Sunday',
]

export function buildFloristJsonLd(): FloristJsonLdGraph {
  return {
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'Florist',
        '@id': `${SITE_BASE_URL}/#florist`,
        name: SITE_NAME,
        url: SITE_BASE_URL,
        email: STORE_INFO.email,
        openingHoursSpecification: [
          {
            '@type': 'OpeningHoursSpecification',
            dayOfWeek: ALL_WEEK_DAYS,
            opens: '10:00',
            closes: '22:00',
          },
        ],
        areaServed: STORE_INFO.deliveryArea,
      },
    ],
  }
}
